import Sortable from 'sortablejs';

jQuery(document).ready(function($) {
  var el = $('.sortable')[0]
  if( el ) {
    Sortable.create(el, {
      onEnd: function (event) {
        var item = event.item
        var params = {
          'id': item.dataset.groupId,
          'seq': event.newIndex + 1,
          'parent_id': item.dataset.parentId
        }
        $.ajax({
          url: el.dataset.url,
          data: params,
          type: 'PATCH'
        })
        location.reload()
      }
    })
  } else { console.log("$('.sortable')[0] not loaded") }
})
